const toolActionsType = {
    hover: "hover",
    dots: "dots",
};

export default toolActionsType;
